import { createSlice } from '@reduxjs/toolkit'

export const riskCriteriaUI = createSlice({
  name: 'riskCriteriaUI',
  initialState: {},
  reducers: {},
})

//export const {  } = riskCriteriaUI.actions

export default riskCriteriaUI.reducer
